<template>
  <b-modal ref="modal" centered :visible="true" @hidden="onModalHidden" class="tabbed">
    <template slot="modal-header">
      <h1>{{ Translations.sections.dayTemplates.edition.title }}</h1>
      <ul class="nav">
        <li :active="modalState.activeTab=='basic'">
          <a
            @click.prevent="modalState.activeTab='basic'"
          >{{Translations.sections.dayTemplates.edition.tabs.basic.title}}</a>
        </li>
        <!--                <li :active="modalState.activeTab=='constraints'">-->
        <!--                    <a @click.prevent="modalState.activeTab='constraints'">{{Translations.sections.dayTemplates.edition.tabs.constraints.title}}</a>-->
        <!--                </li>-->
      </ul>
    </template>
    <template>
      <WaitingBlock v-if="modalState.isLoadingDayTemplate"></WaitingBlock>
      <b-form class="form" v-else>
        <div :class="['tab',{'active' : modalState.activeTab=='basic'}]">
          <input
            type="hidden"
            id="stationUid"
            name="stationUid"
            v-model="dayTemplateData.stationUid"
          />
          <div class="linked-properties">
            <b-form-group
              id="group-name"
              :label="Translations.labels.name"
              label-for="name"
              :label-cols="4"
            >
              <b-form-input
                id="name"
                name="name"
                v-model="dayTemplateData.name"
                type="text"
                required
                autocomplete="off"
                :placeholder="Translations.placeholders.name"
              />
            </b-form-group>
            <b-form-group
              id="color-container"
              :label="Translations.labels.color"
              label-for="colorCode"
              :label-cols="4"
            >
              <b-form-input
                id="name"
                name="colorCode"
                v-model="dayTemplateData.colorCode"
                type="color"
                :placeholder="Translations.placeholders.color"
              />
            </b-form-group>
          </div>
        </div>
        <div :class="['tab', {'active' : modalState.activeTab=='constraints'}]">
          <div class="alert alert-warning">Coming Soon</div>
          <!--<Button :empty="true" noBorder="true" disabled><i class="fas fa-plus"></i>&nbsp;Add Constraint</Button>-->
        </div>
      </b-form>
    </template>
    <template slot="modal-footer">
      <Button
        :empty="true"
        class="close-popup"
        @click.prevent="cancelModal"
      >{{ Translations.buttons.cancel }}</Button>
      <Button
        :empty="false"
        class="validate"
        v-if="!modalState.isLoadingDayTemplate"
        @click.prevent="editDayTemplate"
      >{{ Translations.buttons.doEditDayTemplate }}</Button>
    </template>
  </b-modal>
</template>

<script>
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "DayTemplateEditionCard",
  store,
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    ...mapState(["currentStation"]),
    Translations: function() {
      return Translations;
    },
    errorMessages: function(inputName) {
      if (this.editionResponse == null || this.editionResponse.errors == null)
        return [];
    }
  },
  props: {
    dayTemplateUid: null
  },
  mounted() {
    this.loadDayTemplate();
  },
  watch: {
    currentStation: function() {
      console.log("station loaded");
    },
    dayTemplateUid: function() {
      this.loadDayTemplate();
    }
  },
  data() {
    return {
      modalState: {
        show: true,
        visible: true,
        activeTab: "basic",
        isLoadingDayTemplate: true
      },
      dayTemplateData: null,
      editionResponse: null
    };
  },
  methods: {
    loadDayTemplate() {
      try {
        if (this.currentStation != null && this.dayTemplateUid != null) {
          console.log("Loading dayTemplate for edition");
          this.modalState.isLoadingDayTemplate = true;
          HTTP.get("api/daytemplates/details", {
            params: {
              stationUid: this.currentStation.uid,
              dayTemplateUid: this.dayTemplateUid
            }
          })
            .then(this.onDayTemplateLoaded, this.onDayTemplateLoadError)
            .then(this.onDayTemplateLoadComplete);
          if (this.$refs["modal"]) this.$refs["modal"].show();
        } else {
        }
      } catch (e) {
        console.log("loadDayTemplate -> error:", e);
      }
    },
    onDayTemplateLoaded(response) {
      this.dayTemplateData = response.data.dataItem;
    },
    onDayTemplateLoadError(response) {
      this.dayTemplateData = null;
    },
    onDayTemplateLoadComplete(response) {
      this.modalState.isLoadingDayTemplate = false;
    },

    editDayTemplate() {
      HTTP.post("api/daytemplates/edit", this.dayTemplateData)
        .then(this.onDayTemplateEdited, this.onDayTemplateEditionError)
        .then(function() {
          console.log("End...");
        });
    },
    onDayTemplateEdited(response) {
      console.log(response);
      const { dataItem } = response.data;
      this.$store.commit("onDayTemplateLoaded", dataItem);
      this.editionResponse = response;
      if (this.editionResponse.status == 200) {
        var editedDayTemplateResponse = this.editionResponse.data;
        if (
          editedDayTemplateResponse != null &&
          editedDayTemplateResponse.dataItem != null
        ) {
          //router.push({ name: 'BoxDetails', params: { uid: newBox.dataItem.uid } });
          store.dispatch("loadStationDayTemplates", this.currentStation.uid);
          this.cancelModal();
        }
      } else {
        //let vue build the error messages
      }
      //this.cancelModal();
    },
    onDayTemplateEditionError(response) {
      console.log(response);
      this.editionResponse = response;
      console.error(response);
    },
    cancelModal() {
      this.$refs["modal"].hide(), EventBus.$emit("onDayTemplateEditionEnded");
    },
    onModalHidden() {
      EventBus.$emit("onDayTemplateEditionEnded");
    }
  }
};
</script>

<style>
</style>